import React from "react";
import "./TopButton.css";
import {ThemeProps} from "../../styles/themeprops";

type TopButtonProps = {
  theme:ThemeProps
};

export default function TopButton({ theme }:TopButtonProps) {
  function GoUpEvent() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }

  function scrollFunction() {
	let topBut = document.getElementById("topButton");
	if(topBut){
    if (
      document.body.scrollTop > 30 ||
      document.documentElement.scrollTop > 30
    ) {
      	topBut.style.visibility = "visible";
    } else {
      topBut.style.visibility = "hidden";
    }
    }
  }

  window.onscroll = function () {
    scrollFunction();
  };

  const onMouseEnter = (color:string, bgColor:string) => {
    /* For the button */
    const topButton = document.getElementById("topButton");
    if(topButton){
    topButton.style.color = color;
    topButton.style.backgroundColor = bgColor;
    }

    /* For arrow icon */
    const arrow = document.getElementById("arrow");
    if(arrow){
    arrow.style.color = color;
    arrow.style.backgroundColor = bgColor;
    }
  };

  const onMouseLeave = (color:string, bgColor:string) => {
    /* For the button */
    const topButton = document.getElementById("topButton");
    if(topButton){
    topButton.style.color = color;
    topButton.style.backgroundColor = bgColor;
	}
    /* For arrow icon */
    const arrow = document.getElementById("arrow");
    if(arrow){
    arrow.style.color = color;
    arrow.style.backgroundColor = bgColor;
    }
  };

  return (
    <div
      onClick={GoUpEvent}
      id="topButton"
      style={{
        color: theme.body,
        backgroundColor: theme.primary,
        border: `solid 1px ${theme.secondary}`,
      }}
      title="Go up"
      onMouseEnter={() => onMouseEnter(theme.secondary, theme.body)}
      onMouseLeave={() => onMouseLeave(theme.body, theme.primary)}
    >
      <i className="fas fa-arrow-up" id="arrow" aria-hidden="true" />
    </div>
  );
}
